import { atom } from 'jotai';

/**
 * True once the document "Status" (status-history) section has scrolled into
 * view for the currently open document detail modal. Used to trigger background
 * AI contact enrichment only after the user has engaged with the document.
 *
 * Only one document detail view is open at a time, so a single boolean is
 * sufficient. ModalStatus resets this to false on mount/unmount so it re-arms
 * per modal open and never leaks a stale value into the next document.
 */
export const statusSectionInViewAtom = atom(false);
statusSectionInViewAtom.debugLabel = 'statusSectionInView';
